import RoleForm from '../components/Form'
import useModalForm from '../../../@hooks/useModalForm'
import RoleService from '../../../@services/role'

export default function useCreateRole(cb) {
  const { open } = useModalForm(RoleForm)

  const openDialog = () => {
    return open(
      async req => {
        const res = await RoleService.create(req)
        console.log({ res })
        if (typeof cb === 'function') {
          cb(res)
        }
      },
      {
        permissions: [],
        permissions2: [],
      },
      {
        title: '添加角色',
      }
    )
  }

  return openDialog
}
